import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { XMLHttpRequestHandler_requestType } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { header } from '../header';
import { adminLeads_template } from '../../components/templates/recruiting/adminLeads_template';
import { startListLoading, stopListLoading } from '~/utils/listLoading';
import { createLeadDrawer, createLoadingLeadDrawer } from '~/utils/adminLeadDrawer';
export class admin_leads extends vnModule_knockoutJS {
    constructor() {
        super(...arguments);
        this.leadDrawerKeydownHandler = null;
        this.channelMap = new Map();
        this.subunitMap = new Map();
        this.partnerMap = new Map();
    }
    /**
     * Return the module key used by the Valnet app framework.
     *
     * @return string
     */
    getModuleName() {
        return 'admin_leads';
    }
    /**
     * Build and return the DOM content for this module.
     *
     * @return Array<Element>
     */
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle('Admin Leads');
        this.adminLeads_template = new adminLeads_template('adminLeadsTemplate', this.viewModel, this);
        this.tpl = this.adminLeads_template;
        this.template = this.adminLeads_template;
        return [this.adminLeads_template.build()];
    }
    /**
     * Clean up module-level event listeners.
     *
     * @return void
     */
    cleanup() {
        this.unbindLeadDrawerKeyboard();
        this.setLeadDrawerOpen(false);
        if (this.viewRequest) {
            this.viewRequest.cancelAndReset();
            this.viewRequest = null;
        }
    }
    /**
     * Load the initial data required by the page.
     *
     * @return void
     */
    fillPage() {
        this.adminLeads_template.buildDatePickerCalendar();
        this.getListFormData();
    }
    /**
     * Return list form data.
     *
     * @return void
     */
    getListFormData() {
        startListLoading(this, this.adminLeads_template.builtTemplate);
        const usrReqParams = [];
        usrReqParams.push(['data', ko.toJSON([])]);
        this.XHRHdl = new XMLHttpRequestHandler('/api/admin/rest/api/leads/references', usrReqParams, this);
        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }
    /**
     * Handle the API response for filter request.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onFilterRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                obj.validationTemplate.clearMessages();
                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();
            });
            if (req.request.readyState === 4) {
                stopListLoading(obj, obj.adminLeads_template.builtTemplate);
            }
        };
    }
    /**
     * Update filters.
     *
     * @param responseParsed any
     * @return void
     */
    updateFilters(responseParsed) {
        this.adminLeads_template.setChannels(responseParsed.channels || []);
        this.adminLeads_template.setSendFlags(responseParsed.sendFlags || []);
        this.adminLeads_template.setPartners((responseParsed.partners || []).map((item) => ({
            id: item.id,
            name: item.internalName || item.name || ('Partner #' + item.id),
        })));
        this.adminLeads_template.setSubunits(responseParsed.subunits || []);
        this.channelMap = new Map();
        for (let channel of (responseParsed.channels || [])) {
            this.channelMap.set(Number(channel.id), channel.name || '');
        }
        this.subunitMap = new Map();
        for (let subunit of (responseParsed.subunits || [])) {
            this.subunitMap.set(Number(subunit.id), subunit.name || '');
        }
        this.partnerMap = new Map();
        for (let partner of (responseParsed.partners || [])) {
            this.partnerMap.set(Number(partner.id), {
                name: partner.name || '',
                internalName: partner.internalName || '',
            });
        }
    }
    /**
     * Return list data.
     *
     * @return void
     */
    getListData() {
        startListLoading(this, this.adminLeads_template.builtTemplate);
        const subViewModel = this.adminLeads_template.getViewModelForRequest();
        const baseApiUrl = '/api/admin/rest/api/leads/search';
        this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn, XMLHttpRequestHandler_requestType.GET, 'getListData');
    }
    /**
     * Handle the API response for data request.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onDataRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                const responseParsed = JSON.parse(req.request.response || '{}');
                const rows = (responseParsed.data && responseParsed.data.paginatedData) || responseParsed.data || responseParsed.beans || [];
                const vmReq = obj.adminLeads_template.getViewModelForRequest();
                const totalCount = Number(responseParsed.totalCount || responseParsed.count || 0);
                const perPage = vmReq.pagination && vmReq.pagination.itemPerPage ? Number(vmReq.pagination.itemPerPage) : 50;
                const totalPages = Math.max(1, Number(responseParsed.totalPage || Math.ceil(totalCount / Math.max(1, perPage))));
                const paginationVm = obj.adminLeads_template.getPaginationViewModel();
                const currentPage = paginationVm && typeof paginationVm.pageNumber === 'function'
                    ? Number(paginationVm.pageNumber())
                    : 1;
                // Keep pagination on a valid page after filters reduce results.
                if (paginationVm && totalCount > 0 && currentPage > totalPages) {
                    paginationVm.pageNumber(totalPages);
                    obj.getListData();
                    return;
                }
                if (paginationVm && typeof paginationVm.pageNumber === 'function') {
                    const backendPage = Number(responseParsed.currentPage || currentPage);
                    paginationVm.pageNumber(Math.max(1, backendPage));
                }
                obj.validationTemplate.clearMessages();
                obj.updateList(rows);
                obj.updatePagination(totalCount);
                obj.setResultInfo(totalCount, totalPages, req);
            });
            if (req.request.readyState === 4 && req.request.status !== 0) {
                stopListLoading(obj, obj.adminLeads_template.builtTemplate);
            }
        };
    }
    /**
     * Update list.
     *
     * @param responseParsedData any
     * @return void
     */
    updateList(responseParsedData) {
        const transformedRows = [];
        for (let row of (responseParsedData || [])) {
            transformedRows.push(this.mapRowForTable(row));
        }
        this.adminLeads_template.setRows(transformedRows);
    }
    /**
     * Update the pagination partial with the result count.
     *
     * @param totalCount any
     * @return void
     */
    updatePagination(totalCount) {
        this.adminLeads_template.updatePagination(totalCount);
    }
    /**
     * Update the result-info partial with list metadata.
     *
     * @param totalCount any
     * @param totalPage any
     * @param req any
     * @return void
     */
    setResultInfo(totalCount, totalPage, req) {
        const execTime = Math.round((new Date().getTime() - req.requestStartTime) / 1000 * 100) / 100;
        this.adminLeads_template.setResultInfo(totalCount, totalPage, execTime);
    }
    /**
     * Handle map row for table.
     *
     * @param row any
     * @return any
     */
    mapRowForTable(row) {
        const partnerLabels = [];
        const partnerNames = [];
        const campaignCodes = [];
        const sendFlags = [];
        const partners = row.partners || [];
        for (let partnerXref of partners) {
            const partnerId = Number(partnerXref.id ? partnerXref.id.partnerId : null);
            const partner = this.partnerMap.get(partnerId);
            const displayName = partnerXref.partnerInternalName ||
                partnerXref.partnerName ||
                (partner ? (partner.internalName || partner.name) : '') ||
                ('Partner #' + partnerId);
            const sendFlag = partnerXref.sendFlag ?? '';
            const campaignCode = partnerXref.campaignCode || '';
            partnerNames.push(displayName);
            if (campaignCode) {
                campaignCodes.push(campaignCode);
            }
            if (sendFlag !== '') {
                sendFlags.push(sendFlag);
            }
            partnerLabels.push(displayName + ', Send Flag: ' + sendFlag);
        }
        const createdDate = this.formatDateTime(row.createdDate || row.dateCreated || row.createdAt || '');
        const uniquePartnerNames = Array.from(new Set(partnerNames)).join(' | ');
        const uniqueCampaignCodes = Array.from(new Set(campaignCodes)).join(' | ');
        const uniqueSendFlags = Array.from(new Set(sendFlags));
        const firstSendFlag = uniqueSendFlags.length > 0 ? Number(uniqueSendFlags[0]) : Number(row.sendFlag || 0);
        const statusLabel = uniqueSendFlags.length > 0
            ? uniqueSendFlags.map((sendFlag) => this.formatSendFlag(sendFlag)).join(' | ')
            : this.formatSendFlag(row.sendFlag ?? row.status ?? '');
        return {
            id: row.id,
            email: row.email || '',
            channelName: row.channelName || this.channelMap.get(Number(row.channelId)) || '',
            subunitName: row.subunitName || this.subunitMap.get(Number(row.subunitId)) || '',
            createdDate,
            createdDateLabel: createdDate,
            partnerName: uniquePartnerNames || row.partnerName || row.partner || '',
            campaignName: uniqueCampaignCodes || row.campaignName || row.campaign || '',
            sendFlag: firstSendFlag,
            sendFlagName: statusLabel,
            statusLabel,
            googleClickId: row.googleClickId || row.gclId || row.gclid || row.vendorLeadId || row.externalSource || row.internalSource || row.referrer || '',
            externalSource: row.externalSource || '',
            internalSource: row.internalSource || '',
            state: row.state || '',
            partnersLabel: partnerLabels.join(' | '),
            selected: !!row.selected,
        };
    }
    formatSendFlag(value) {
        switch (Number(value)) {
            case 1:
                return 'Sent';
            case 2:
                return 'Rejected';
            case 0:
                return 'Pending';
            default:
                return value !== '' && value !== null && typeof value !== 'undefined' ? String(value) : '';
        }
    }
    /**
     * Handle format date time.
     *
     * @param value string
     * @return string
     */
    formatDateTime(value) {
        if (!value) {
            return '';
        }
        const d = new Date(value);
        if (isNaN(d.getTime())) {
            return value;
        }
        return d.toLocaleString();
    }
    /**
     * Handle filter simple on change changes.
     *
     * @return void
     */
    filterSimpleOnChange() {
        this.resetPageNumber();
        this.getListData();
    }
    /**
     * Handle filter simple cancel changes.
     *
     * @return void
     */
    filterSimpleCancel() {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
    }
    /**
     * Handle filter multiple selector on change changes.
     *
     * @return void
     */
    filterMultipleSelectorOnChange() {
        this.resetPageNumber();
        this.getListData();
    }
    /**
     * Handle filter date on change changes.
     *
     * @return void
     */
    filterDateOnChange() {
        this.resetPageNumber();
        this.getListData();
    }
    /**
     * Handle filter dropdown on change changes.
     *
     * @return void
     */
    filterDropdownOnChange() {
        this.resetPageNumber();
        this.getListData();
    }
    /**
     * Handle pagination click events.
     *
     * @return void
     */
    paginationOnPageClick() {
        this.getListData();
    }
    /**
     * Handle list reorder.
     *
     * @return void
     */
    listReorder() {
        this.getListData();
    }
    /**
     * Handle reset to first page.
     *
     * @return void
     */
    resetToFirstPage() {
        this.resetPageNumber();
    }
    /**
     * Reset the list pagination to the first page.
     *
     * @return void
     */
    resetPageNumber() {
        this.adminLeads_template.resetPageNumber();
    }
    /**
     * Handle toggle row.
     *
     * @param rowId number
     * @return void
     */
    toggleRow(rowId) {
        const rows = this.tpl.getTemplateViewModel().rows() || [];
        for (let row of rows) {
            if (Number(row.id) === Number(rowId)) {
                row.selected = !row.selected;
                break;
            }
        }
        this.tpl.getTemplateViewModel().rows.valueHasMutated();
    }
    /**
     * Handle toggle all rows.
     *
     * @return void
     */
    toggleAllRows() {
        const rows = this.tpl.getTemplateViewModel().rows() || [];
        let shouldSelectAll = false;
        for (let row of rows) {
            if (!row.selected) {
                shouldSelectAll = true;
                break;
            }
        }
        for (let row of rows) {
            row.selected = shouldSelectAll;
        }
        this.tpl.getTemplateViewModel().rows.valueHasMutated();
    }
    /**
     * Handle download csv.
     *
     * @return void
     */
    downloadCsv() {
        const vmReq = this.tpl.getViewModelForRequest();
        const params = [];
        params.push(['pageNumber', String(vmReq.pagination && vmReq.pagination.pageNumber ? vmReq.pagination.pageNumber() : 1)]);
        params.push(['size', String(vmReq.pagination && vmReq.pagination.itemPerPage ? vmReq.pagination.itemPerPage : 50)]);
        params.push(['sortBy', vmReq.sortBy || 'createdDate']);
        params.push(['sortDirection', vmReq.sortDirection || 'DESC']);
        if (this.hasParamValue(vmReq.dateFrom))
            params.push(['dateFrom', String(vmReq.dateFrom)]);
        if (this.hasParamValue(vmReq.dateTo))
            params.push(['dateTo', String(vmReq.dateTo)]);
        if (this.hasParamValue(vmReq.keyword))
            params.push(['keyword', String(vmReq.keyword)]);
        if (this.hasParamValue(vmReq.channelId))
            params.push(['channelId', String(vmReq.channelId)]);
        if (this.hasParamValue(vmReq.sendFlag))
            params.push(['sendFlag', String(vmReq.sendFlag)]);
        const partnerIds = this.normalizeIdList(vmReq.partnerIds);
        const subunitIds = this.normalizeIdList(vmReq.subunitIds);
        if (partnerIds.length > 0)
            params.push(['partnerIds', partnerIds.join(',')]);
        if (subunitIds.length > 0)
            params.push(['subunitIds', subunitIds.join(',')]);
        let query = '';
        let sep = '?';
        for (let param of params) {
            query += sep + param[0] + '=' + encodeURIComponent(param[1]);
            sep = '&';
        }
        window.open('/api/admin/rest/api/leads/download' + query, '_blank');
    }
    /**
     * Ignore undefined/null/empty placeholder values in query params.
     */
    hasParamValue(value) {
        if (typeof value === 'undefined' || value === null) {
            return false;
        }
        const normalized = String(value).trim().toLowerCase();
        if (normalized === '' || normalized === 'undefined' || normalized === 'null') {
            return false;
        }
        return true;
    }
    /**
     * Normalize id arrays and drop undefined/null/empty values.
     */
    normalizeIdList(values) {
        if (!Array.isArray(values)) {
            return [];
        }
        const normalized = values
            .filter((value) => this.hasParamValue(value))
            .map((value) => String(value).trim());
        return Array.from(new Set(normalized));
    }
    /**
     * Handle view lead.
     *
     * @param id number
     * @return void
     */
    viewLead(id) {
        if (this.viewRequest) {
            this.viewRequest.cancelAndReset();
        }
        this.openLeadDrawer(createLoadingLeadDrawer(id));
        this.viewRequest = new XMLHttpRequestHandler('/api/admin/rest/api/leads/' + id, [], this);
        this.viewRequest.onReadyStateFunction = this.onViewLeadReturn;
        this.viewRequest.execute();
    }
    /**
     * Close the lead details drawer.
     *
     * @return void
     */
    closeLeadDrawer() {
        if (this.viewRequest) {
            this.viewRequest.cancelAndReset();
            this.viewRequest = null;
        }
        this.unbindLeadDrawerKeyboard();
        this.tpl.closeLeadDrawer();
        this.setLeadDrawerOpen(false);
    }
    /**
     * Handle the API response for view lead.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onViewLeadReturn(req, obj) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }
            const isCurrentRequest = obj.viewRequest === req;
            obj.manageResponse(req, obj, function () {
                if (!isCurrentRequest) {
                    return;
                }
                const responseParsed = JSON.parse(req.request.response || '{}');
                obj.openLeadDrawer(createLeadDrawer(responseParsed, {
                    channels: obj.channelMap,
                    subunits: obj.subunitMap,
                    partners: obj.partnerMap,
                }));
            });
            if (!isCurrentRequest) {
                return;
            }
            if (req.request.status !== 200 && req.request.status !== 0) {
                obj.closeLeadDrawer();
            }
            obj.viewRequest = null;
        };
    }
    /**
     * Open the lead drawer and bind Escape while it is visible.
     *
     * @param drawer any
     * @return void
     */
    openLeadDrawer(drawer) {
        this.tpl.setLeadDrawer(drawer);
        this.setLeadDrawerOpen(true);
        this.bindLeadDrawerKeyboard();
    }
    /**
     * Track the drawer state for global header layering fixes.
     *
     * @param isOpen boolean
     * @return void
     */
    setLeadDrawerOpen(isOpen) {
        document.body.classList.toggle('admin-leads-drawer-open', isOpen);
    }
    /**
     * Bind Escape to the open lead details drawer.
     *
     * @return void
     */
    bindLeadDrawerKeyboard() {
        if (this.leadDrawerKeydownHandler) {
            return;
        }
        this.leadDrawerKeydownHandler = (event) => {
            if (event.key === 'Escape') {
                this.closeLeadDrawer();
            }
        };
        document.addEventListener('keydown', this.leadDrawerKeydownHandler);
    }
    /**
     * Remove Escape listener for the lead details drawer.
     *
     * @return void
     */
    unbindLeadDrawerKeyboard() {
        if (!this.leadDrawerKeydownHandler) {
            return;
        }
        document.removeEventListener('keydown', this.leadDrawerKeydownHandler);
        this.leadDrawerKeydownHandler = null;
    }
    /**
     * Update selected leads.
     *
     * @return Promise<void>
     */
    async updateSelectedLeads() {
        const rows = this.tpl.getTemplateViewModel().rows() || [];
        const selectedIds = rows.filter((row) => !!row.selected).map((row) => Number(row.id));
        if (selectedIds.length === 0) {
            return;
        }
        const sendFlagRaw = this.tpl.getTemplateViewModel().updateSendFlag();
        const sendFlag = sendFlagRaw === '' || sendFlagRaw === null ? null : Number(sendFlagRaw);
        const payload = {
            leadIds: selectedIds,
            clearTransmissionFields: !!this.tpl.getTemplateViewModel().clearTransmissionFields(),
        };
        if (sendFlag !== null && !isNaN(sendFlag)) {
            payload.sendFlag = sendFlag;
        }
        try {
            const response = await fetch('/api/admin/rest/api/leads', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });
            const responseJson = await response.json();
            if (!response.ok) {
                alert(responseJson.message || 'Unable to update selected leads.');
                return;
            }
            this.tpl.getTemplateViewModel().clearTransmissionFields(false);
            this.tpl.getTemplateViewModel().updateSendFlag('');
            this.getListData();
        }
        catch (e) {
            alert('Unable to update selected leads.');
        }
    }
}
